export default __webpack_public_path__ + "static/media/b-6.341bfea3.png";